<template>
  <div>
    <div class="login">
      <div v-if="isLogoShow ===''" class="logo">
        <router-link to="/">
          <img alt="Vue logo" :src="require('@/assets/img/logo.png')"  />
        </router-link>
      </div>
      <slot name="form" />
      <!--      <slot name="content" />-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    center: {
      type: Boolean,
      default: false
    },
    isLogoShow: {
      type: String,
      default: ''
    }
  }
}
</script>
